import { isAudioJournalId } from 'helpers/audioJournal';
import { PlayedMedia } from 'types';
import { UpdateAllPlayedMedia, UpdatePlayedMedia, UPDATE_ALL_PLAYED_MEDIA, UPDATE_PLAYED_MEDIA } from './actions';

export function playedMediaReducer(curState: PlayedMedia = {}, action: UpdatePlayedMedia | UpdateAllPlayedMedia) {
	switch (action.type) {
		case UPDATE_PLAYED_MEDIA:
			if (isAudioJournalId(action.articleId)) {
				return audioJournalPlayed(curState, action);
			}
			if (!action.force && action.time - (curState[action.articleId]?.time ?? 0) <= 10) {
				return curState;
			}

			let time = action.force ? action.time : Math.max(curState[action.articleId]?.time ?? 0, action.time);
			if (time === curState[action.articleId]?.time) {
				return curState;
			}

			var state = { ...curState };

			state[action.articleId] = {
				time: time,
				timestamp: new Date().getTime(),
			};

			return state;
		case UPDATE_ALL_PLAYED_MEDIA:
			return action.playedMedia;
		default:
			return curState;
	}
}

// An audio journal is listened to by chapter, back and forth: it resumes from where the listener last
// was, not the furthest point reached. Positions under 5 s are ignored (every play reports 0:00
// before it moves to the resume point), as are moves of 10 s or less, as for other media.
function audioJournalPlayed(curState: PlayedMedia, action: UpdatePlayedMedia) {
	const current = curState[action.articleId]?.time;
	if (!action.force && (action.time < 5 || (current !== undefined && Math.abs(action.time - current) <= 10))) {
		return curState;
	}
	if (action.time === current) {
		return curState;
	}
	return { ...curState, [action.articleId]: { time: action.time, timestamp: new Date().getTime() } };
}
